import { Navigate, useLocation } from "react-router-dom";
import { useSidebarNav } from "@/contexts/SidebarNavContext";

/**
 * Redirects to home when the current path is not allowed for this entreprise
 * (sidebar-configured feature pages).
 */
export function SidebarRouteGuard({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { loading, canAccessPath } = useSidebarNav();

  if (loading) {
    return <>{children}</>;
  }

  const path = location.pathname || "/";
  // Always allow auth-ish / static shells that may sit outside the menu.
  if (
    path.startsWith("/login") ||
    path.startsWith("/register") ||
    path.startsWith("/invite")
  ) {
    return <>{children}</>;
  }

  if (!canAccessPath(path)) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
